import script from "./GoalDone.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalDone.vue?vue&type=script&setup=true&lang=ts"

import "./GoalDone.vue?vue&type=style&index=0&id=1ec9f65c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec9f65c"]])

export default __exports__